import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { IpCell } from "@/components/IpCell";
import type { AuditRow } from "@/types";

export function AuditLog() {
  const [rows, setRows] = useState<AuditRow[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api<AuditRow[]>("/api/admin/audit?limit=500")
      .then(setRows)
      .catch((e) => setErr(e?.message ?? "load failed"));
  }, []);

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-3xl display">Audit log</h1>
        <p className="text-sm text-slate-400">
          Append-only. Secret values are redacted before persistence.
        </p>
      </header>
      {err && <div className="card text-rose-300 text-sm">{err}</div>}
      <div className="card p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-slate-500 uppercase tracking-wide bg-white/5">
            <tr>
              <th className="py-3 px-4">Time</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Subject</th>
              <th>IP</th>
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            {rows === null && (
              <tr>
                <td className="py-4 px-4 text-slate-500" colSpan={6}>
                  Loading…
                </td>
              </tr>
            )}
            {rows?.map((r) => (
              <tr key={r.id} className="border-t border-white/5 align-top">
                <td className="py-3 px-4 text-slate-400 whitespace-nowrap">
                  {r.ts ? new Date(r.ts).toLocaleString() : "-"}
                </td>
                <td className="text-slate-400">{r.actor_id ?? "—"}</td>
                <td className="mono text-xs">{r.action}</td>
                <td className="text-slate-400 mono text-xs">
                  {r.subject_type}#{r.subject_id}
                </td>
                <td><IpCell ip={r.ip} /></td>
                <td>
                  <details>
                    <summary className="text-slate-500 cursor-pointer text-xs">view</summary>
                    <pre className="text-[10px] text-slate-400 bg-black/40 rounded p-2 mt-1 max-w-md overflow-auto">
                      {JSON.stringify({ before: r.before, after: r.after }, null, 2)}
                    </pre>
                  </details>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
